<div class="modal-header">
  <div class="modal-title">
    <h2>Zu produzierende Abrufe bearbeiten</h2>
  </div>
</div>

<div class="modal-body">

  <div class="row">
    <div class="col-sm-12">
      <table class="table whitetable">
        <thead>
          <tr>
            <th>Abruf</th>
            <th>Artikelstatus</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>Menge</th>
            <th>Spätester End-Termin</th>
            <th>Kunden Liefertermin</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (fetch of fetches; track trackByFn(index, fetch); let index = $index) {
            <tr>
              <td>{{ fetch.fetch.ordering }}</td>
              <td>
                <fetch-article-usage-state-label [fetchState]="fetch.fetch.status.id"
                  [articleUsageState]="fetch.fetch.article_usage_state">
                </fetch-article-usage-state-label>
              </td>
              <td><span [ngClass]="'label label-' + fetch.fetch.status.label">{{ fetch.fetch.status.name }}</span></td>
              <td>@if (fetch.express) {
                <span class="label label-danger">EILDIENST</span>
              }</td>
              <td>{{ fetch.position.quanity|money }}</td>
              <td>{{ fetch.last_work_day }}</td>
              <td>{{ fetch.fetch.delivery }}</td>
              <td>
                @if (fetch.fetch.status.id === FETCH_STATUS.PRODUCTION) {
                  <button type="button"
                    class="btn btn-sm"
                    (click)="revert(fetch)">
                    <i class="fa fa-history" aria-hidden="true"></i>
                  </button>
                }
                @if (fetch.fetch.status.id === FETCH_STATUS.CONTRACT && !fetch.selected) {
                  <button type="button"
                    class="btn btn-sm btn-success"
                    (click)="toggle(fetch)">
                    Hinzufügen
                  </button>
                }
                @if (fetch.selected) {
                  <button type="button"
                    class="btn btn-sm btn-danger"
                    (click)="toggle(fetch)">
                    Entfernen
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-danger pull-left" (click)="dismiss()">
    Abbrechen
  </button>
  <button class="btn btn-sm btn-success pull-right" (click)="submit()" [disabled]="!selected">
    Übernehmen
  </button>
</div>
